export default __webpack_public_path__ + "static/media/science.111255a1.svg";